var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn w-100 btn-primary my-3",attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.clicked()}}},[(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }